import _styled from "styled-components";
var _excluded = ["children", "id", "onClick", "size"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { OutlineButton } from "../../Button/OutlineButton/OutlineButton";
import * as styles from "./styles";
/** @deprecated use `IconButton` instead */
export var RoundButton = function RoundButton(_ref) {
  var children = _ref.children,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? '' : _ref$id,
    onClick = _ref.onClick,
    size = _ref.size,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(_StyledOutlineButton, _extends({
    id: id,
    onClick: onClick
  }, props, {
    $_css: [styles.buttonOverrides, size === 'small' ? styles.small : styles.large]
  }), children);
};
var _StyledOutlineButton = /*#__PURE__*/_styled(OutlineButton).withConfig({
  displayName: "RoundButton___StyledOutlineButton",
  componentId: "sc-3bp4qr-0"
})(["", ""], function (p) {
  return p.$_css;
});